/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimulationTask } from '../../models/simulation-task';

export interface SimulationTasksTaskIdTaskGet$Params {
  taskId: string;
}

export function simulationTasksTaskIdTaskGet(http: HttpClient, rootUrl: string, params: SimulationTasksTaskIdTaskGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationTask>> {
  const rb = new RequestBuilder(rootUrl, simulationTasksTaskIdTaskGet.PATH, 'get');
  if (params) {
    rb.path('taskId', params.taskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SimulationTask>;
    })
  );
}

simulationTasksTaskIdTaskGet.PATH = '/simulation-tasks/{taskId}/task';
